<template>
    <div class="edit-form">
        <b-container fluid>
            <b-row>
                <b-col xl="5" lg="4" class="fixed-div">
                    <b-row class="full-height" >
                        <b-col class="align-self-center text-center">
                            <h1><img class="logo" src="../../assets/imgs/domik_white_logo.svg" alt=""></h1>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col offset-xl="5" xl="7"  offset-lg="4" lg="8" class="order-container">
                    <b-container>
                        <b-row>
                            <b-col class="mb-3">
                                <router-link :to="{ name: 'Orders'}" class="btn-back"> Volver</router-link>
                            </b-col>
                            <b-col cols="12" class="mb-3">
                                <h3>Editar orden</h3>
                            </b-col>
                            <b-col cols="12" class="mb-3">
                                <single-select
                                    v-model="dataUser.hospital.name"
                                    :options="optionsHospitals"
                                    placeholder=""
                                    :required="true"
                                    :key="optionsHospitals.lenght"
                                    :label="'Selecciona el Hospital al que perteneces'"
                                ></single-select>
                            </b-col>
                            <b-col cols="12" class="mb-3 form-floating">
                                <single-select
                                    v-model="dataUser.area.name"
                                    :options="optionsAreas"
                                    :key="optionsAreas.lenght"
                                    placeholder=""
                                    :required="true"
                                    :label="'Selecciona tu Sub Configuración de Puesto'"
                                ></single-select>
                            </b-col>
                            <b-col cols="12" class="mb-3 form-floating">
                                <single-select
                                    v-model="dataUser.position.name"
                                    :options="optionsJobPosition"
                                    placeholder=""
                                    :required="true"
                                    :label="'Selecciona tu Puesto'"
                                ></single-select>
                            </b-col>
                            <b-col cols="12" class="mb-3 form-floating" v-if="dataUser.area.name=='Dirección Médica'">
                                <b-form-input id="input-4" v-model="dataUser.speciality" placeholder="Especialidad" type="text"></b-form-input>
                                <label for="input-4">Especialidad</label> 
                            </b-col>
                            <b-col cols="12" class="mb-3 form-floating">
                                <input type="text" class="form-control" v-model="dataUser.name" placeholder="Nombres(s)" id="input-1">
                                <label for="input-1">Nombre(s)</label>
                            </b-col>
                            <b-col cols="12" md="6" class="mb-3 form-floating">
                                <b-form-input id="input-2" v-model="dataUser.first_lastname" placeholder="Apellido Paterno" type="text"></b-form-input>    
                                <label for="input-2">Apellido Paterno</label>            
                            </b-col>
                            <b-col cols="12" md="6" class="mb-3 form-floating">
                                <b-form-input id="input-3" v-model="dataUser.second_lastname" placeholder="Apellido Materno" type="text"></b-form-input> 
                                <label for="input-3">Apellido Materno</label>
                            </b-col>
                            <b-col cols="12" class="mb-3">
                                <div class="radioBtn radioBtn-border">
                                    <b-form-radio-group
                                        id="btn-radios-1"
                                        v-model="dataUser.gender.name"
                                        :options="optionsGender"
                                        button-variant="outline-primary"
                                        size="lg"
                                        name="radio-btn-outline"
                                         :class="{'active': dataUser.gender.name}"
                                        buttons
                                    ></b-form-radio-group>
                                </div>
                            </b-col>
                            <b-col v-if="hasClothesType.scrub" :key="hasClothesType.scrub" cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                <fieldset>
                                    <legend>Filipina {{hasClothesType.scrub}}</legend>
                                    <label :class="{'show': dataUser.scrub_size}" for="">Talla de Filipina</label>
                                    <vue-single-select
                                        :key="dataUser.gender.name"
                                        v-model="dataUser.scrub_size"
                                        :options="optionsSizes"
                                        placeholder=""
                                        :required="true"
                                    ></vue-single-select>
                                </fieldset>
                            </b-col>
                            <b-col v-if="hasClothesType.scrub" :key="hasClothesType.scrub" cols="12" md="6" lg="12"  xl="6" :class="{'show': dataUser.scrub_qty}" class="mb-3 size-container pt-2">
                                <div class="qty-container">
                                    <label for="input-6">Cantidad</label>
                                    <vue-numeric-input
                                        id="input-6"
                                        :min="0"
                                        v-model="dataUser.scrub_qty"
                                        className="form-control-qty"
                                        controls-type="updown">
                                    </vue-numeric-input>
                                </div>
                            </b-col>
                            <b-col v-if="hasClothesType.pant" :key="hasClothesType.pant" cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                <fieldset>
                                    <legend>Pantalón {{hasClothesType.pant}}</legend>
                                    <label :class="{'show': dataUser.pants_size}" for="">Talla de Pantalón</label>
                                    <vue-single-select
                                        :key="dataUser.gender.name"
                                        v-model="dataUser.pants_size"
                                        :options="optionsSizes"
                                        placeholder=""
                                        :required="true"
                                    ></vue-single-select>
                                </fieldset>
                            </b-col>
                            <b-col v-if="hasClothesType.pant" :key="hasClothesType.pant" cols="12" md="6" lg="12"  xl="6" :class="{'show': dataUser.pants_qty}" class="mb-3 size-container pt-2">
                                <div class="qty-container">
                                    <label for="input-7">Cantidad</label>
                                    <vue-numeric-input
                                        id="input-7"
                                        :min="0"
                                        v-model="dataUser.pants_qty"
                                        className="form-control-qty"
                                        controls-type="updown">
                                    </vue-numeric-input>
                                </div>
                            </b-col>
                            <b-row v-for="(item, id) in hasClothesType.coat" :key="id" style="padding: 0!important; margin: 0 !important">
                                <b-col cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                    <fieldset>
                                        <legend>Bata {{item}}</legend>
                                        <label :class="{'show': (id==0 ? dataUser.coat_size : dataUser.coat_size2)}" for="">Talla de Bata</label>
                                        <vue-single-select v-if="id==0"
                                            :key="dataUser.gender.name"
                                            v-model="dataUser.coat_size"
                                            :options="dataUser.gender.name==='Hombre' ? optionsSizesMen : optionsSizes"
                                            placeholder=""
                                            :required="true"
                                        ></vue-single-select>
                                        <vue-single-select v-else
                                            v-model="dataUser.coat_size2"
                                            :options="dataUser.gender.name==='Hombre' ? optionsSizesMen : optionsSizes"
                                            placeholder=""
                                            :required="true"
                                        ></vue-single-select>
                                    </fieldset>
                                </b-col>
                                <b-col :key="hasClothesType.coat" v-if="hasClothesType.coat" cols="12" md="6" lg="12"  xl="6" :class="{'show': (id==0 ? dataUser.coat_qty : dataUser.coat_qty2)}" class="mb-3 size-container pt-2">
                                    <div class="qty-container">
                                        <label for="input-8">Cantidad</label>
                                        <vue-numeric-input
                                            v-if="id==0"
                                            id="input-8"
                                            :min="0"
                                            v-model="dataUser.coat_qty"
                                            className="form-control-qty"
                                            controls-type="updown">
                                        </vue-numeric-input>
                                        <vue-numeric-input
                                            v-else
                                            id="input-8"
                                            :min="0"
                                            v-model="dataUser.coat_qty2"
                                            className="form-control-qty"
                                            controls-type="updown">
                                        </vue-numeric-input>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-col v-if="hasClothesType.scrubCap" :key="hasClothesType.scrubCap" cols="12" md="6" lg="12"  xl="6" class="mb-3">
                                <fieldset>
                                    <legend>Cubrepolvos {{hasClothesType.scrubCap}}</legend>
                                    <label :class="{'show': dataUser.scrub_cap_size}" for="">Talla de Cubrepolvos</label>
                                    <vue-single-select
                                        :key="dataUser.gender.name"
                                        v-model="dataUser.scrub_cap_size"
                                        :options="dataUser.gender.name==='Hombre' ? optionsSizesMen : optionsSizes"
                                        placeholder=""
                                        :required="true"
                                    ></vue-single-select>
                                </fieldset>
                            </b-col>
                            <b-col v-if="hasClothesType.scrubCap" :key="hasClothesType.scrubCap" cols="12" md="6" lg="12"  xl="6" :class="{'show': dataUser.scrub_cap_qty}" class="mb-3 size-container pt-2">
                                <div class="qty-container">
                                    <label for="input-9">Cantidad</label>
                                    <vue-numeric-input
                                        id="input-9"
                                        :min="0"
                                        v-model="dataUser.scrub_cap_qty"
                                        className="form-control-qty"
                                        controls-type="updown">
                                    </vue-numeric-input>
                                </div>
                            </b-col>
                            <b-col cols="12" class="mb-3" v-if="dataUser.area.name=='Dirección Médica'">
                                <div class="radioBtn-border  embroid-container" :class="{'show': dataUser.embroid}">
                                    <label for="input-10">Bordado</label>
                                    <div class="radioBtn">
                                        <b-form-radio-group
                                            id="btn-radios-2"
                                            v-model="dataUser.embroid"
                                            :options="optionsEmbroidery"
                                            button-variant="outline-primary"
                                            size="lg"
                                            name="radio-btn-outline"
                                            :class="{'active': dataUser.embroid}"
                                            buttons
                                        ></b-form-radio-group>
                                    </div>
                                </div>
                                
                            </b-col>
                            <b-col cols="12" v-if="dataUser.embroid=='Sí'" :key="dataUser.embroid" class="mb-3 form-floating">
                                <b-form-input id="input-4" v-model="dataUser.embroid_text" placeholder="Texto a borda" type="text"></b-form-input>
                                <label for="input-4">Texto a bordar</label> 
                            </b-col>
                            <b-col cols="12" v-if="dataUser.embroid=='Sí'" :key="dataUser.embroid" class="mb-3">
                                <p class="note"><strong>NOTA.</strong> Recuerda que al seleccionar bordado se usará de referencia el texto tal cual usted lo haya escrito en los campos anteriores, siendo estos nombre, apellido paterno, apellido materno y especialidad. Respetaremos mayúsculas, minúsculas, acentos y cualquier otro caracter especial y/o errores ortográficos.</p>
                            </b-col>
                            <b-col cols="12" class="mb-3 form-floating">
                                <b-form-input id="input-11" v-model="dataUser.phone" placeholder="Teléfono de Contacto" type="text"></b-form-input> 
                                <label for="input-11">Teléfono de Contacto</label>
                            </b-col>
                            <b-col cols="12" class="mb-3 form-floating">
                                <b-form-input id="input-12" v-model="dataUser.mail" placeholder="Correo Electrónico" type="text"></b-form-input> 
                                <label for="input-12">Correo Electrónico</label>
                            </b-col>
                            <b-col md="10">
                                <b-button v-on:click="updateOrder">
                                    <div v-if="!loading">Actualizar</div>
                                    <b-spinner v-else variant="light"></b-spinner>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-container>
                    
                    <b-modal id="modal-center text-center" centered hide-footer v-model="showModal">
                        <h3 class="text-center mb-5">{{messageModal}}</h3>
                    </b-modal>
                    
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import VueSingleSelect from 'vue-single-select'
    import SingleSelect from '../elements/SingleSelect.vue'
    import VueNumericInput from 'vue-numeric-input'
    import axios from 'axios'
    import qs from 'qs'

    export default {
        components: {
            VueSingleSelect,
            SingleSelect,
            VueNumericInput
        },
        created() {
            var token = sessionStorage.getItem('api_token')
            var id_user = sessionStorage.getItem('id_user')
            var is_admin = sessionStorage.getItem('is_admin');
            if (is_admin!= 'yes'){
                this.$router.push('/orden')
            }

            axios
            .post(
                process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
                qs.stringify({ 
                    api_token: token, 
                    user_id: id_user,
                    option: 'get_order',
                    order_id: this.$route.params.orderId,
                }),
            )
            .then((response) => {
                if (!response.data.error.code) {
                    this.dataUser = response.data.order
                }
            })
            .catch((err) => {
                console.log(err)
            })


            axios
            .post(
                process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
                qs.stringify({ 
                    api_token: token, 
                    user_id: id_user,
                    option: 'get_catalogs',
                }),
            )
            .then((response) => {
                if (!response.data.error.code) {
                    var listHospitals = [],
                        listComplete = [],
                        listGender = []
                    this.optionsGenderAPI = response.data.gender
                    Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
                        listHospitals.push(value[0].name)
                        listComplete.push(value[0])
                    })
                    Object.keys(response.data.gender).map((key) => [response.data.gender[key]]).map(function(value) {
                        listGender.push(value[0])
                    })
                    this.optionsHospitals = listHospitals
                    this.optionsHospitalsComplete = listComplete
                    this.optionsGenderAPI = listGender
                }
            })
            .catch((err) => {
                console.log(err)
            })
                
        },
        data() {
            return {
                dataUser: {},
                optionsHospitals: [],
                optionsHospitalsComplete: [],
                optionsGenderAPI: [],
                optionsSizes: ['XXS','XS','S','M','L','XL','XXL','XXXL','XXXXL'],
                optionsSizesMen: ['32','34','36','38','40','42','44','46','48','50','52'],
                optionsGender: [
                    { text: 'Hombre', value: 'Hombre' },
                    { text: 'Mujer', value: 'Mujer' }
                ],
                optionsEmbroidery: [
                    { text: 'Sí', value: 'Sí' },
                    { text: 'No', value: 'No' }
                ],
                empty: false,
                loading: false,
                messageModal: '',
                showModal: false
            }
        }, 
        methods: {
            updateOrder() {
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')
                this.loading = true
                this.empty = true
                // if(1) {    
                    axios
                    .post(
                        process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
                        qs.stringify({ 
                            order_id: this.$route.params.orderId,
                            api_token: token, 
                            user_id: id_user,
                            option: 'edit_order',
                            hospital_name: this.dataUser.hospital.name,
                            area_name: this.dataUser.area.name,
                            order_name: this.dataUser.name,
                            order_firstLastname: this.dataUser.first_lastname,
                            order_secondLastname: this.dataUser.second_lastname,
                            order_speciality: this.dataUser.speciality,
                            order_embroid: this.dataUser.embroid,
                            order_gender: this.dataUser.gender.name,
                            order_phone: this.dataUser.phone,
                            order_mail: this.dataUser.mail,
                            order_scrubSize: this.dataUser.scrub_size,
                            order_scrubQty: this.dataUser.scrub_qty,
                            order_pantsSize: this.dataUser.pants_size,
                            order_pantsQty: this.dataUser.pants_qty,
                            order_coatSize: this.dataUser.coat_size,
                            order_coatSize2: this.dataUser.coat_size2,
                            order_coatQty: this.dataUser.coat_qty,
                            order_coatQty2: this.dataUser.coat_qty2,
                            coat_model: this.dataUser.coat_model,
                            coat_model2: this.dataUser.coat_model2,
                            position_name: this.dataUser.position.name,
                            order_scrubCapSize: this.dataUser.scrub_cap_size,
                            order_scrubCapQty: this.dataUser.scrub_cap_qty,
                            order_embroid_text: this.dataUser.embroid_text,
                        }),
                    )
                    .then((response) => {
                        this.loading = false
                        if (response.data.error.code==0 && response.data.order) {
                            this.messageModal = "La orden de actualizó exitosamente"
                            this.showModal = true
                        } else {
                            this.messageModal = "No se actualizó la orden"
                            this.showModal = true
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                // }
            }
        },
        computed: {
            optionsAreas: function() {
                if (this.dataUser.hospital.name) {
                    let temp = this.optionsHospitalsComplete.filter((x) =>
                    x.name === this.dataUser.hospital.name)
                    return temp.map(x => x.sharedArea)[0].map(y => y.name) 
                } else {
                    return ['']
                }
            },
            optionsJobPosition: function() {
                 if (this.dataUser.hospital.name && this.dataUser.area.name) {
                    let temp = this.optionsHospitalsComplete.filter((x) =>
                    x.name === this.dataUser.hospital.name).map(x => x.sharedArea)[0].filter((x) =>
                    x.name === this.dataUser.area.name)
                    return temp.map(x => x.ownPosition)[0].map(y => y.name) 
                } else {
                    return ['']
                }
            },
            optionsModelsCoat:  function() {
                if (this.dataUser.hospital.name && this.dataUser.area.name && this.dataUser.gender.name) {
                    let     gender = this.optionsGenderAPI.filter((x) => x.name === this.dataUser.gender.name).map(y => y.id),
                            catalog = this.optionsHospitalsComplete.filter((x) =>
                                        x.name === this.dataUser.hospital.name)[0].sharedArea.filter((x) =>
                                        x.name === this.dataUser.area.name)[0].catalog.sharedModel.filter((x) =>
                                        x.gender_id == gender).filter((x) => x.type_id === '3'),
                            listComplete = []
                                        
                            Object.keys(catalog).map((key) => [catalog[key]]).map(function(value) {
                                listComplete.push(value[0].name)
                            })
                    return listComplete 
                } else {
                    return ['']
                }
            },
            hasClothesType: function(){
                if (this.dataUser.hospital.name && this.dataUser.area.name) {
                    let elements = {
                        scrub: '',
                        pant: '',
                        coat: '',
                        scrubCap: ''
                    },
                        gender = this.optionsGenderAPI.filter((x) => x.name === this.dataUser.gender.name)[0].id,
                        catalog = this.optionsHospitalsComplete.filter((x) =>
                                    x.name === this.dataUser.hospital.name)[0].sharedArea.filter((x) =>
                                    x.name === this.dataUser.area.name)[0].catalog.sharedModel.filter((x) =>
                                    x.gender_id == gender)
                                    
                    elements.scrub = catalog.filter((x) => x.type_id === '1').map(y => y.name).toString()
                    elements.pant = catalog.filter((x) => x.type_id === '2').map(y => y.name).toString()
                    elements.coat = catalog.filter((x) => x.type_id === '3').map(y => y.name)
                    elements.scrubCap  = catalog.filter((x) => x.type_id === '4').map(y => y.name).toString()
                    return elements 
                } else {
                    return ''
                }
            }
        }
    }
</script>

<style scoped>
.order-container{
    padding: 70px 12% 70px 7%;
}
.full-height{
    height: 100vh;
}
.fixed-div{
    position: fixed;
    background: #5A6FBE;
    background-image: url('../../assets/imgs/img_photo.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    max-height: 100vh;
}
h3{
    font-weight: bold;
    font-size: 25px;
}
span{
    font-size: 16px;
    color: #5965B1;
}
p{
   font-size: 14px; 
}
.note{
    font-size: 14px;
    color: #5965B1;
}
.btn,
.btn:focus,
.btn:hover{
    background: #24A7DF;
    border: none;
    width: 100%;
}
.btn-group{
    width: 100%;
}
legend {
    color: rgba(89, 101, 177, 1);
    float: none;
    width: fit-content;
    padding: 0;
    margin-bottom: 0.5rem;
    margin-left: 1rem;
    font-size: 15px;
    line-height: inherit;
    margin-bottom: 0;
}
fieldset{
    border: 1px solid #5965B1;
    border-radius: 5px;
    position: relative;
}
fieldset label{
    position: absolute;
    left: 1rem;
    bottom: 25%;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
fieldset label.show{
    color: rgba(89, 101, 177, 1) !important;
}
.size-container{
    position: relative;
}

.size-container label{
    position: absolute;
    left: 1rem;
    bottom: 25%;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
.size-container.show label{
    color: rgba(89, 101, 177, 1) !important;
}
.size-container.coat-container label{
    left: calc(2rem - 2px);
    color: rgba(89, 101, 177, 0.4);
}
.size-container.coat-container.show label{
    color: rgba(89, 101, 177, 1) !important;
}
.qty-container{
    position: relative;
    width: 100%;
    border:1px solid #5965B1 !important;
    border-radius: 5px;
    padding: 0.4rem 0.5rem;
    height: 100%;
}
.radioBtn-border{
    border: 1px solid rgba(89, 101, 177, 1);
}
.embroid-container{
    border-radius: 5px;
    width: 100%;
    display: -webkit-flex;
    display: flex;
}
.embroid-container label{
    margin-right: 20px;
    margin-left: 1.1rem;
    margin-top: 0.6rem;
    z-index: 2;
    font-size: 20px;
    color: rgba(89, 101, 177, 0.4);
}
.embroid-container.show label{
    color: rgba(89, 101, 177,1) !important;
}
.embroid-container .radioBtn{
    width: inherit;
}
.btn-back{
    text-decoration: none;
    color: #5965B1;
    border: 1px solid #5965B1;
    width: fit-content;
    padding: 5px 20px;
    border-radius: 5px;
}

@media (max-width: 1600px) {
    .order-container{
        padding: 70px 10% 70px 6%;
    }
    h3{
        font-size: 20px;
    }
    p{
        font-size: 12px; 
    }
    .note{
        font-size: 11px;
    }
    legend {
        font-size: 12px;
    }
    .logo{
        width: 70%;
    }
    .qty-container{
        height: 45px;
    }
    .size-container label{
        bottom: 25%;
        font-size: 14px;
    }
    .size-container.coat-container label{
        left: 2rem;
        font-size: 14px;
    }
    .embroid-container label,
    fieldset label{
        font-size: 14px;
    }
}
@media (max-width: 991px) {
    .fixed-div{
        position: relative;
        background: #5A6FBE;
        padding: 10% 0;
        width: 100%;
        overflow-x: hidden;
    }
    .full-height{
        height: fit-content;
    }
}

@media (max-width: 768px) {
    .order-container{
        padding: 50px 5% 50px 5%;
    }
}
</style>

